import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rangePlaceholderText',
  standalone: true
})
export class RangePlaceholderTextPipe implements PipeTransform {
  transform(start: string, end: string, isMandatory = false, isDesktop?: boolean, currentLang?: string): string {
    const mandatoryText = isMandatory ? '* ' : '';
    const desktopFormat = this.getDesktopFormat(start, end, mandatoryText);
    const isDesktopFormat = isDesktop === undefined || currentLang === undefined || isDesktop || !start || !end;
    return isDesktopFormat ? desktopFormat : this.getMobileFormat(start, end, currentLang, mandatoryText);
  }

  private getDesktopFormat(startDate: string, endDate: string, mandatoryText: string): string {
    return endDate ? `${mandatoryText}${startDate} - ${endDate}` : `${mandatoryText}${startDate}`;
  }

  private getMobileFormat(start: string, end: string, currentLang: string, mandatoryText: string): string {
    const formattedDates = this.formatTripDates(this.stringToDate(start), this.stringToDate(end), currentLang);
    return `${mandatoryText}${formattedDates}`;
  }

  private formatTripDates(start: Date, end: Date, currentLang: string): string {
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit' };
    const formatter = new Intl.DateTimeFormat(currentLang, options);
    const formattedStartDate = formatter.format(start);
    const formattedEndDate = formatter.format(end);
    return `${formattedStartDate} - ${formattedEndDate}`;
  }

  private stringToDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day);
  }
}
